define('configuration/templates.configuration',['require','exports','module','underscore','templates','marionette','bluebird'],function(require, exports, module) {
  //prettier-ignore
  var _         = require('underscore'),
      Templates = require('templates'),
      Mn        = require('marionette'),
      Promise   = require('bluebird');

  var TemplatesConfiguration = {
    radioEvents: {
      'app configure': 'onAppConfigure',
    },

    onAppConfigure: function(app) {
      Mn.TemplateCache.get = function(templateId, options) {
        if (!_.has(Templates.App, templateId)) {
          Promise.reject(
            new Error(
              'The template file "' + templateId + '.hbs" does not exist. Please add it to the "src/template" folder.'
            )
          );
          return _.noop;
        }
        return Templates.App[templateId];
      };
    },
  };
  module.exports = TemplatesConfiguration;
});

